import React from 'react';
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';

const Home = () => {

    const carouselHotelRooms = {
        stagePadding: 200,
        loop: true,
        margin: 10,
        items: 1,
        lazyLoad: true,
        autoHeight: false,
        autoplay: true,
        dots: false,
        nav: true,
        navText: ['<i class="ti-angle-left" aria-hidden="true"></i>', '<i class="ti-angle-right" aria-hidden="true"></i>'],

        responsive: {
            0: {
                items: 1,
                stagePadding: 60
            },
            600: {
                items: 1,
                stagePadding: 100
            },
            1000: {
                items: 1,
                stagePadding: 200
            },
            1200: {
                items: 1,
                stagePadding: 250
            },
            1400: {
                items: 1,
                stagePadding: 250
            },
            1600: {
                items: 1,
                stagePadding: 300
            },
            1800: {
                items: 1,
                stagePadding: 200
            }
        }
    };

    const carouselSingleSlider = {
        loop: true,
        margin: 0,
        mouseDrag: true,
        autoplay: true,
        // autoplayTimeout: 9000,
        dots: false,
        autoplayHoverPause: false,
        nav: true,
        navText: ["<span class='lnr ti-angle-left'></span>", "<span class='lnr ti-angle-right'></span>"],
        responsiveClass: true,
        items: 1
    };
    const carouselEvents = {
        autoplay: false,
        loop: true,
        margin: 10,
        nav: true,
        navText: ["<span class='lnr ti-angle-left'></span>", "<span class='lnr ti-angle-right'></span>"],
        dots: true,
        responsive: {
            0: {
                items: 1
            },

            600: {
                items: 3
            },

            1024: {
                items: 4
            },

            1366: {
                items: 4
            },

            1650: {
                items: 4
            }
        }
    };
    const carouselReview = {
        loop: true,
        margin: 10,
        mouseDrag: true,
        autoplay: true,
        dots: true,
        nav: true,
        navText: ["<span class='lnr ti-angle-left'></span>", "<span class='lnr ti-angle-right'></span>"],
        responsiveClass: true,
        responsive: {
            0: {
                items: 1
            },

            600: {
                items: 2
            },

            1024: {
                items: 3
            },

            1366: {
                items: 3
            },

            1650: {
                items: 4
            }
        }
    };
    return (
        <>
            <header className="header">
                <div className="video-fullscreen-wrap">
                    <div className="video-fullscreen-video">
                        <OwlCarousel className="owl-theme first-carousel" {...carouselSingleSlider}>
                           
                            <div className="item">
                                <img src="img/slider/Rajgir-b.jpg" loading="lazy" alt="hotel" />
                            </div>
                            <div className="item">
                                <img src="img/slider/Bodhgaya.jpg" loading="lazy" alt="hotel" />
                            </div>
                            <div className="item">
                                <img src="img/slider/Sravasti.jpg" loading="lazy" alt="hotel" />
                            </div>

                            <div className="item">
                                <img src="img/slider/Rajgir-a.jpg" loading="lazy" alt="hotel" />
                            </div>
                            <div className="item">
                                <img src="img/slider/Rajgir-c.jpg" loading="lazy" alt="hotel" />
                            </div>
                            <div className="item">
                                <img src="img/slider/Rajgir-d.jpg" loading="lazy" alt="hotel" />
                            </div>
                            <div className="item">
                                <img src="img/slider/Rajgir-e.jpg" loading="lazy" alt="hotel" />
                            </div>
                            <div className="item">
                                <img src="img/slider/Rajgir-f.jpg" loading="lazy" alt="hotel" />
                            </div>
                           

                        </OwlCarousel>

                    </div>
                    <div className="v-middle caption overlay">
                        <div className="container">
                            <div className="row justify-content-center">
                                <div className="col-lg-12 col-md-12"> <span>
                                    <i className="star-rating"></i>
                                    <i className="star-rating"></i>
                                    <i className="star-rating"></i>
                                    <i className="star-rating"></i>
                                    <i className="star-rating"></i>
                                </span>
                                    <h1>Residency Group Hotels</h1>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <a href="/" data-scroll-nav="1" className="mouse smoothscroll" aria-label="Scroll to section">
                    <span className="mouse-icon">
                        <span className="mouse-wheel"></span>
                    </span>
                </a>

            </header>


            <section className="abouts section-padding" style={{ backgroundImage: `url(img/pattern.png)` }}>
                <div className="container">
                    <div className="row">

                        <div className="col-md-12">
                            <div className="section-title">About Us</div>

                            <div className="row">
                                <div className="col-lg-12 col-md-12">
                                    <p>Welcome to the Residency Group of Hotels, a pioneering hospitality chain in Bihar and Uttar Pradesh, dedicated to uplifting and showcasing Buddhist and Jain culture and tourism in India. With properties in Rajgir, Bodhgaya, Vaishali, and Sravasti, we offer serene retreats for inbound and domestic tourists and pilgrims.</p>
                                    <p>Our hotels blend modern comforts with a deep connection to the region's rich Buddhist and Jain heritage, providing an immersive experience for guests. Beyond accommodations, we host conferences, parties, marriages, and corporate stays, catering to diverse needs.</p>
                                    <p>We've created a haven for travelers seeking spiritual growth, cultural exploration, and memorable experiences. Join us for a journey of discovery and tranquility in the heart of  Buddhist and Jain circuit.</p>
                                    <p></p>
                                    <div className="section-titl">Our Locations </div>
                                    <ul className='lo_lst'>
                                        <li>
                                            <img src='img/location.png' alt='pin' className='locton' />
                                            <p>(Bihar)</p>
                                            <h6>Bodhgaya</h6>
                                        </li>
                                        <li>
                                            <img src='img/location.png' alt='pin' className='locton' />
                                            <p>(Bihar)</p>
                                            <h6>Rajgir </h6>
                                        </li>
                                        <li>
                                            <img src='img/location.png' alt='pin' className='locton' />
                                            <p>(Bihar)</p>
                                            <h6>Vaishali </h6>
                                        </li>
                                        <li>
                                            <img src='img/location.png' alt='pin' className='locton' />
                                            <p>(Uttar Pradesh)</p>
                                            <h6>Sravasti </h6>
                                        </li>

                                    </ul>

                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="rooms1 section-padding">
                <div className="container">
                    <div className="row mb-30">

                        <div className="col-md-12">
                            <div className="section-title">Explore More</div>
                            <p> Discover serene hotels and resorts in key Buddhist pilgrimage sites, offering a blend of modern comforts and spiritual significance. Our properties in Rajgir, Bodhgaya, Vaishali, and Sravasti provide peaceful retreats for travelers seeking to explore the rich Buddhist heritage of Bihar and Uttar Pradesh.</p>
                        </div>
                    </div>
                    <OwlCarousel className="owl-theme second-carousel" {...carouselHotelRooms}>
                        <div className="rooms1-single">
                            <div className="rooms1-img"> <img src="img/rooms/Bodhgaya.jpg" loading="lazy" alt="hotel" /> </div>
                            <div className="rooms1-content">
                                <div className="row">
                                    <div className="col-md-9">
                                        <div className="rooms1-title"><a href="/Bodhgaya-Residency">The Residency, Bodhgaya</a></div>
                                        <div className="rooms1-tagline">The Residency is Newly Opened Most Beautiful Luxury Property ...</div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="book">
                                            <div><a href="/Bodhgaya-Residency" className="butn-dark2"><span>View</span></a></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="rooms1-single">
                            <div className="rooms1-img"> <img src="img/rooms/Rajgir.jpg" loading="lazy" alt="hotel" /> </div>
                            <div className="rooms1-content">
                                <div className="row">
                                    <div className="col-md-9">
                                        <div className="rooms1-title"><a href="/Rajgir-Residency">The Rajgir Residency</a></div>
                                        <div className="rooms1-tagline">he Rajgir Residency Is An Exemplary Piece Of Architecture ...</div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="book">
                                            <div><a href="/Rajgir-Residency" className="butn-dark2"><span>View</span></a></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="rooms1-single">
                            <div className="rooms1-img"> <img src="img/rooms/Vaishali.jpg" loading="lazy" alt="hotel" /> </div>
                            <div className="rooms1-content">
                                <div className="row">
                                    <div className="col-md-9">
                                        <div className="rooms1-title"><a href="/Vaishali-Residency">The Vaishali Residency </a></div>
                                        <div className="rooms1-tagline">The Vaishali Residency Is The Most Elegant Luxury Hotel In Buddhist Circuit... </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="book">
                                            <div><a href="/Vaishali-Residency" className="butn-dark2"><span>View</span></a></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="rooms1-single">
                            <div className="rooms1-img"> <img src="img/rooms/Sravasti.jpg" loading="lazy" alt="hotel" /> </div>
                            <div className="rooms1-content">
                                <div className="row">
                                    <div className="col-md-9">
                                        <div className="rooms1-title"><a href="/Sravasti-Residency">The Sravasti Residency </a></div>
                                        <div className="rooms1-tagline">The Sravasti Residency is Newly Opened Most Beautiful Luxury...</div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="book">
                                            <div><a href="/Sravasti-Residency" className="butn-dark2"><span>View</span></a></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </OwlCarousel>

                </div>
            </section>

            <section className="section-padding bg-white">
                <div className="container">
                    <div className="row mb-30">
                        <div className="col-md-12">
                            <div className="section-title">A Closer Look</div>
                        </div>
                    </div>
                    <div className="row">
                        <OwlCarousel className="owl-theme first-carousel" {...carouselEvents}>
                            {[2, 14, 15, 16].map((num) => (
                                <div className="item" key={num}>
                                   
                                    <video
                                        controls
                                        preload="metadata"
                                        playsInline
                                        muted
                                        style={{
                                            objectFit: "cover",
                                            width: "100%",
                                            height: "100%",
                                        }}
                                    >
                                        <source src={`videos/video-${num}.mp4`} type="video/mp4" />
                                        Your browser does not support the video tag.
                                    </video>
                                </div>
                            ))}
                        </OwlCarousel>
                    </div>
                </div>
            </section>
            <section className='book_hotel_now' style={{ backgroundImage: `url(img/bg-enqery.jpg)` }}>
                <div className='container'>
                    <div className='row'>
                        <div className='col-md-4'>
                            <img src="img/qury.png" loading="lazy" alt="hotel" />
                        </div>
                        <div className='col-md-8 Htl_booking'>
                            <h3>Looking for a Hotel?</h3>
                            <p>Find the perfect stay for your next trip. Comfortable rooms, great locations, and top-notch service – all at the best prices.</p>
                            <a href="/contact-us" className='butn-dark2'>Contact Us</a>
                        </div>
                    </div>
                </div>
            </section>

            <section className="section-padding testimonials">
                <div class="background bg-img bg-fixed section-padding pb-0" data-overlay-dark="4" style={{ backgroundImage: `url(img/rooms/testimonial.jpg)` }}>
                    <div className="container">
                        <div className="row mb-30">
                            <div className="col-md-12">
                                <div className="section-title">What They say</div>
                                <p>Feedback from our lovely customers.</p>
                            </div>
                        </div>
                        <div className="row">
                            <div className='col-md-12'>
                                <OwlCarousel className="owl-theme first-carousel" {...carouselReview}>
                                    <div className='item'>
                                        <div className='reviewBox'>
                                            <span>
                                                <i class="star-rating"></i>
                                                <i class="star-rating"></i>
                                                <i class="star-rating"></i>
                                                <i class="star-rating"></i>
                                                <i class="star-rating"></i>
                                            </span>
                                            <h5>"It was very good stay , Location is very good near hills &Rooms are
                                                decent & Clean .Overall superb stay."</h5>
                                            <div class="info">
                                                <div class="author-img"> <img src="img/team/1.jpg" loading="lazy" alt="hotel" /> </div>
                                                <div class="cont">
                                                    <h6>Mr. Prahlad kumar</h6>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='item'>
                                        <div className='reviewBox'>
                                            <span>
                                                <i class="star-rating"></i>
                                                <i class="star-rating"></i>
                                                <i class="star-rating"></i>
                                                <i class="star-rating"></i>
                                                <i class="star-rating"></i>
                                            </span>
                                            <h5>"Best for Weekend stay,Surroundings are good with all
                                                Accommodation,finally good experience staffs are good
                                                And cooperatives"</h5>
                                            <div class="info">
                                                <div class="author-img"> <img src="img/team/1.jpg" loading="lazy" alt="hotel" /> </div>
                                                <div class="cont">
                                                    <h6>Mr.	Mahfuz Sattar </h6>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='item'>
                                        <div className='reviewBox'>
                                            <span>
                                                <i class="star-rating"></i>
                                                <i class="star-rating"></i>
                                                <i class="star-rating"></i>
                                                <i class="star-rating"></i>
                                                <i class="star-rating"></i>
                                            </span>
                                            <h5>"Felt good while entering the premises .We received warm welcome
                                                At the reception.The suite is quite large and decorated beautifully.
                                                With 2 washroom ,big sitting space,Hill view window and clean swimming
                                                Pool,Rajgir Residency will be my 1st choice in this area . Breakfast was
                                                Delicious.I shall always remember the ultimate taste of omelette, Also
                                                It’s pets friendly and my cat really enjoyed the ambience"</h5>
                                            <div class="info">
                                                <div class="author-img"> <img src="img/team/1.jpg" loading="lazy" alt="hotel" /> </div>
                                                <div class="cont">
                                                    <h6>Mr.	Rajendra Kumar </h6>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='item'>
                                        <div className='reviewBox'>
                                            <span>
                                                <i class="star-rating"></i>
                                                <i class="star-rating"></i>
                                                <i class="star-rating"></i>
                                                <i class="star-rating"></i>
                                                <i class="star-rating"></i>
                                            </span>
                                            <h5>"our stay at Rajgir residency was very good .the location of the hotel is very good.
                                                The room was spacious and clean .The food service and ambience were also very
                                                Good .The staff of the hotel was very courteous."</h5>
                                            <div class="info">
                                                <div class="author-img"> <img src="img/team/1.jpg" loading="lazy" alt="hotel" /> </div>
                                                <div class="cont">
                                                    <h6>Mr. Rajesh Pandey</h6>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </OwlCarousel>
                            </div>
                        </div>
                    </div>
                </div>
            </section>



            <section className="Mpa_loct">
                <iframe src="https://www.google.com/maps/d/embed?mid=1tQB9hwZ6L7A5JnpJA8HKbB-RIk8I0M8&ehbc=2E312F" width="100%" height="480" frameborder="0" class="mappie" allowfullscreen title="Google Map - The Residency Hotel"></iframe>

            </section>

        </>
    )
};
export default Home;